// extracted by mini-css-extract-plugin
module.exports = {"root":"PlayerProgressBar_root__2LSay","bufferedOverlay":"PlayerProgressBar_bufferedOverlay__B4Rm-"};